/**
 * Checks if the code is running in a browser environment.
 *
 * @returns {boolean} True if running in a browser, false otherwise.
 */
export const isBrowser = typeof window !== 'undefined';
